/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import {
	Button,
	Card,
	CardHeader,
	CardBody,
	FormGroup,
	Form,
	Input,
	Container,
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Label,
} from "reactstrap";
import Purchaser from '../../lib/Core/Backend/Controllers/Purchaser';
// core components
import UserHeader from "components/PurchaserFrontend/Headers/UserHeader.js";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import NotificationAlert from "react-notification-alert";
import Notify from "lib/Utils/Alert";
import Catalogs from "lib/Core/Backend/Controllers/Catalogs";
import { MotionButton } from "components/Core/MotionStrap";
import Utils from "lib/Utils/Utils";
import FromValidator from "lib/Utils/FormValidator";
import PaymentOptions from "components/Purchaser/PaymentOptions";
import useCatalogs from "hooks/useCatalogs";
import ConfirmationAlert from '../../components/ConfirmationAlert/ConfirmationAlert';

const mapKeys = {
  street: 'street',
  city: 'city',
  postalCode: 'zipcode',
  countryId: 'countryId'
}

const PurchaserProfile = (props) =>
{
	const {purchaserId, token} = props;

	const {paymentOptions, countries} = useCatalogs()

	const purchaserCtl = useMemo(() => new Purchaser(token),[token]);
	const catalogsCtl = useMemo(() => new Catalogs(token), [token]);


	const [addressModal, setAddressModal] = useState(false);
	const [purchaser, setPurchaser] = useState({});
	const [users, setUsers] = useState([]);
	const [primaryContact, setprimaryContact] = useState(null);
	const [brands, setBrands] = useState([]);
	const [user, setuser] = useState({
		phone: '',
		contactFirstName: '',
		contactLastName: '',
		email: '',
	});
	const [showAlertMessage, setShowAlertMessage] = useState(false)

	const toggleAddressModal = () => setAddressModal(!addressModal);
	const stayModal = () => setShowAlertMessage(false)

	const [reload, setReload] = useState(false);

	const toggleReload = () => setReload(!reload);

	const alert = useRef();
	const infoForm = useRef();
	const addressData = useRef();
	const addressForm = useRef();

	const prepareToEditAddress = (e) => {
		e.preventDefault();
		e.stopPropagation();

		toggleAddressModal();
	};

	const prepareAddressForm = () => {
		if(addressForm.current){
			Utils.FillDropdown(addressForm.current.countryId, countries.map(country => country));
			if(!addressData.current){
				return
			}
			addressForm.current.street.value = addressData.current.street ?? '';
			addressForm.current.city.value = addressData.current.city ?? '';
			addressForm.current.zipcode.value = addressData.current.postalCode ?? '';
			addressForm.current.countryId.value = addressData.current.countryId ?? '-1';
			
			
		}
	};

	const finishOperation = () => {
		if (addressForm.current) {
      const av = new FromValidator(addressForm.current, (type, message) => Notify(alert, type, message),
				[
					{label: "Street and Number", property: "street", required: true},
					{label: "City", property: "city", required: true},
					{label: "Postal or Zip Code", property: "postalCode", input: "zipcode", required: true},
					{label: "Country", property: "countryId", required: true, noVal: "-1"}
				]
			);

			if (!av.isFormValid())
				return;

			let addressInfo = av.getDTO();

			addressInfo.purchaserId = purchaserId;

			purchaserCtl.updateAddress(addressInfo, addressData => {
				if (addressData.errorMessage || addressData.error)
				{
					Notify(alert, "danger", addressData.errorMessage ?? addressData.error);
				} else {
					Notify(alert, "info", "Address successfully edited");
					toggleAddressModal();
					toggleReload();
				}
			});
		}
	};

	const setAddress = useCallback(data => {
		if(data && !data.error){
			addressData.current = data;
			if(infoForm.current){
				infoForm.current['input-address'].value = data.street ?? '';
				infoForm.current['input-city'].value = data.city ?? '';
				infoForm.current['input-country'].value = countries
					.find(country => country.id === parseInt(data.countryId)).name ?? '-1';
				infoForm.current['input-postal-code'].value = data.postalCode;
			}
		} else {
			Notify(alert, 'danger', data.errorMessage ?? data.error)
		}
	}, [countries]);




	useEffect(() => {
		if(!!purchaserId){
			purchaserCtl.purchaser(purchaserId, purchaserData => {
				if(purchaserData.error || purchaserData.errorMessage){
					Notify(alert, 'danger', purchaserData.errorMessage ?? purchaserData.error)
				} else {
					setPurchaser(purchaserData);
				}
			})
		}

	}, [purchaserId, catalogsCtl, purchaserCtl]);

	useEffect(() => {
		if(!!purchaserId){
			purchaserCtl.address(purchaserId, setAddress);
		}
		
	}, [reload, purchaserId, purchaserCtl, setAddress]);

	useEffect(() => {
		if(purchaserId){
			purchaserCtl.contacts(purchaserId, data => {
				if(data.error || data.errorMessage){
					setprimaryContact(null)
				} else {
					setprimaryContact(data.find(contact => contact.purchaserContactTypeId === 1))
				}
			})
	
			purchaserCtl.users(purchaserId, data => {
				if(data.error || data.errorMessage){
					setUsers([])
				} else {
					setUsers(data)
				
				}
				})
	
			purchaserCtl.availableBrands(purchaserId, data => {
				if(data.error || data.errorMessage){
					setBrands([])
				} else {
					setBrands(data.brands)
				}
			})
		}
	}, [purchaserCtl, purchaserId]);

	useEffect(() => {
		let decodedToken = JSON.parse(sessionStorage.getItem('accessToken')).decodedToken

		if(decodedToken){
			purchaserCtl.contactByCognito(decodedToken.username, data => {
				if(!(data.error || data.errorMessage)){
					setuser(data)
				}
			})
		}
	}, [purchaserCtl]);

	const handleModalClose = () => {
    const formHasChanges = modelChange(addressData.current, addressForm.current)
		if (formHasChanges){
			setShowAlertMessage(true)
		} else {
			setAddressModal(!addressModal)
		}
  }

  const leaveAllModal = () => {
		setShowAlertMessage(false)
		setAddressModal(false)
	}

  const modelChange = (initial, endModel) => {
		let changed = false
		Object.entries(initial).forEach(([key, value]) => {
			if (endModel[mapKeys[key]] && value !== endModel[mapKeys[key]].value) {
				changed = true
				return
			}
		})
		return changed
	}

	return (
		<>
			<NotificationAlert ref={alert} />
			<ConfirmationAlert stayModal={stayModal} openModal={showAlertMessage} leaveModal={leaveAllModal} />
			<UserHeader/>
			{/* Page content */}
			<Container className="mt--7" fluid>
				<Row>
					<Col className="order-xl-2 mb-5 mb-xl-0" xl="4">
						<Card className="card-profile shadow">
							<CardBody className="pt-0">
								<Row className="mt-5 justify-content-center">
									<Col md={8} >
										{purchaserId && <PaymentOptions  paymentOptions={paymentOptions} purchaser={purchaser}/>}
									</Col>
								</Row>
								<Row>
									<div className="col">
										<div className="card-profile-stats d-flex justify-content-center mt-md-5">
											<div>
												<span className="heading">{users.length}</span>
												<span className="description">Users</span>
											</div>
											<div>
												<span className="heading">{brands.length}</span>
												<span className="description">Brands Available</span>
											</div>
										</div>
									</div>
								</Row>
								<div className="text-center">
									<h2>
										Primary Contact Information
									</h2>
									<h3>
										{primaryContact ? `${primaryContact.contactFirstName} ${primaryContact.contactLastName}` : ''}
									</h3>
									<div className="h5 mt-4">
										<i className="ni business_briefcase-24 mr-2"/>
										{primaryContact ? primaryContact.email : ''}
									</div>
									<hr className="my-4"/>
								</div>
							</CardBody>
						</Card>
					</Col>
					<Col className="order-xl-1" xl="8">
						<Card className="bg-secondary shadow">
							<CardHeader className="bg-white border-0">
								<Row className="align-items-center">
									<Col xs="8">
										<h3 className="mb-0">My account</h3>
									</Col>
									<Col className="text-right" xs="4">
										<Button
											color="primary"
											href="#pablo"
											onClick={(e) => e.preventDefault()}
											size="sm"
										>
											Settings
										</Button>
									</Col>
								</Row>
							</CardHeader>
							<CardBody>
								<Form innerRef={infoForm}>
									<h6 className="heading-small text-muted mb-4">
										User information
									</h6>
									<div className="pl-lg-4">
										<Row>
											<Col lg="6">
												<FormGroup>
													<label
														className="form-control-label"
														htmlFor="input-username"
													>
														Username
													</label>
													<Input
														className="form-control-alternative"
														defaultValue=""
														id="input-username"
														value={user.email}
														placeholder="Username"
														type="text"
													/>
												</FormGroup>
											</Col>
											<Col lg="6">
												<FormGroup>
													<label
														className="form-control-label"
														htmlFor="input-phone"
													>
														Phone
													</label>
													<Input
														className="form-control-alternative"
														id="input-phone"
														placeholder=""
														value={user.phone}
														type="text"
													/>
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col lg="6">
												<FormGroup>
													<label
														className="form-control-label"
														htmlFor="input-first-name"
													>
														First name
													</label>
													<Input
														className="form-control-alternative"
														defaultValue=""
														value={user.contactFirstName}
														id="input-first-name"
														placeholder="First name"
														type="text"
													/>
												</FormGroup>
											</Col>
											<Col lg="6">
												<FormGroup>
													<label
														className="form-control-label"
														htmlFor="input-last-name"
													>
														Last name
													</label>
													<Input
														className="form-control-alternative"
														defaultValue=""
														value={user.contactLastName}
														id="input-last-name"
														placeholder="Last name"
														type="text"
													/>
												</FormGroup>
											</Col>
										</Row>
									</div>
									<hr className="my-4"/>
									{/* Address */}
									<h6 className="heading-small text-muted mb-4">
										Contact information
									</h6>
									<div className="pl-lg-4">
										<Row>
											<Col md="12">
												<FormGroup>
													<label
														className="form-control-label"
														htmlFor="input-address"
													>
														Address
													</label>
													<Input
														className="form-control-alternative bg-white"
														disabled={true}
														defaultValue="Not available"
														id="input-address"
														placeholder="Home Address"
														type="text"
													/>
												</FormGroup>
											</Col>
										</Row>
										<Row>
											<Col lg="4">
												<FormGroup>
													<label
														className="form-control-label"
														htmlFor="input-city"
													>
														City
													</label>
													<Input
														className="form-control-alternative bg-white"
														disabled={true}
														defaultValue="Not available"
														id="input-city"
														placeholder="City"
														type="text"
													/>
												</FormGroup>
											</Col>
											<Col lg="4">
												<FormGroup>
													<label
														className="form-control-label"
														htmlFor="input-country"
													>
														Country
													</label>
													<Input
														className="form-control-alternative bg-white"
														disabled={true}
														defaultValue="Not available"
														id="input-country"
														placeholder="Country"
														type="text"
													/>
												</FormGroup>
											</Col>
											<Col lg="4">
												<FormGroup>
													<label
														className="form-control-label"
														htmlFor="input-country"
													>
														Postal code
													</label>
													<Input
														className="form-control-alternative bg-white"
														disabled={true}
														id="input-postal-code"
														defaultValue="Not available"
														placeholder="Postal code"
														type="text"
													/>
												</FormGroup>
											</Col>
										</Row>
										<Row className="justify-content-end">
											<Col md="auto">
												<MotionButton initial={{x: "-500%", opacity: 0}} animate={{x: 0, opacity: 1, transition: {delay: 0.4, duration: 0.5}}} color="primary" onClick={prepareToEditAddress}>
													<i className="fas fa-map-marker-alt"/>{' '}Edit
												</MotionButton>
											</Col>
										</Row>
									</div>
								</Form>
							</CardBody>
						</Card>
					</Col>
				</Row>
				<Modal isOpen={addressModal} toggle={toggleAddressModal} backdrop="static" centered={true} size="md" onOpened={prepareAddressForm}>
          <ModalHeader toggle={handleModalClose} className='bg-info'>Edit Address</ModalHeader>
          <ModalBody>
            <Form innerRef={addressForm}>
							<Row form>
							  <Col md={12}>
									<FormGroup>
										<Label for="street">Street and number</Label>
										<Input type="text" id="street" name="street" placeholder="Street name, number and internal number" maxLength="70"/>
									</FormGroup>
								</Col>
							</Row>
							<Row form>
							  <Col md={4}>
									<FormGroup>
										<Label for="city">City</Label>
										<Input type="text" id="city" name="city" placeholder="City" maxLength="50"/>
									</FormGroup>
								</Col>
								<Col md={4}>
									<FormGroup>
										<Label for="zipcode">Postal or Zip Code</Label>
										<Input type="text" name="zipcode" id="zipcode" placeholder="Zip Code" maxLength="7"/>
									</FormGroup>
								</Col>
								<Col md={4}>
									<FormGroup>
										<Label for="countryId">Country</Label>
										<Input type="select" name="countryId" id="countryId">
											<option value="-1">Select a country</option>
										</Input>
									</FormGroup>
								</Col>
							</Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" onClick={handleModalClose}>Cancel</Button>
            <Button type="button" color="primary" onClick={finishOperation}>Save</Button>
          </ModalFooter>
        </Modal>
			</Container>
		</>
	);
};

export default PurchaserProfile;
